export class ConnectToAddressAction {
    constructor(address, scanTimeout = null) {
        this.name = 'ConnectToAddress';
        this.isDeviceAction = false;
        this.data = {};
        this.data.address = address;
        this.data.scanTimeout = scanTimeout;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29ubmVjdFRvQWRkcmVzc0FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvQ29ubmVjdFRvQWRkcmVzc0FjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNQSxNQUFNLE9BQU8sc0JBQXNCO0lBS2pDLFlBQVksT0FBZSxFQUFFLGNBQXNCLElBQUk7UUFKdkMsU0FBSSxHQUFHLGtCQUFrQixDQUFDO1FBQzFCLG1CQUFjLEdBQUcsS0FBSyxDQUFDO1FBQ2hDLFNBQUksR0FBNkIsRUFBRyxDQUFDO1FBRzFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztRQUM1QixJQUFJLENBQUMsSUFBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7SUFDdEMsQ0FBQztDQUNGIn0=